/**
 * @typedef {import('./state').SearchState} SearchState
 */

/**
 * @type {import('vuex').GetterTree<SearchState, SearchState>}
 */
export const getters = {
  isInitializing: (state) => state.actionState === 'INITIALIZING',
  isLoading: (state) =>
    state.actionState === 'INITIALIZING' || state.actionState === 'LOADING',
  results: (state) => state.response.results,
  orderBy: (state) => state.request.orderBy,
  pageNumber: (state) => state.response.pageNumber,
  pageSize: (state) => state.response.pageSize,
  totalCount: (state) => state.response.totalCount,
  contentTypeTaxonomies: (state) => state.response.contentTypeTaxonomies,
  searchTerm: (state) => {
    return state.request.term;
  },
  filterGroups: (state) => state.response.groups,
  maxRelevance: (state) => state.maxRelevance,
  content: (state) => state.content,
  orderByOptions: (state) => state.orderByOptions,
  culture: (state) => state.culture,
  cdnDomain: (state) => state.cdnDomain,
  relevanceTiers(state) {
    const interval = state.maxRelevance / 3;

    return [0, interval, interval * 2];
  },
};
